// Components
import { DialogerSetup } from '@hooks/index';
// Types
import { Set } from '@globalTypes/store';
import { DialogerStoreState } from './useDialogerStore.types';

/**
 * Sets the dialoger setup in the dialoger store state.
 * @param set - The state setter function for the dialoger store state.
 * @param isOpen - Indicates whether the dialoger is open or closed.
 * @param newSetup - The new dialoger setup (optional).
 */
const setDialogerSetup = (set: Set<DialogerStoreState>) => (isOpen: boolean, newSetup?: DialogerSetup) =>
  set(({ dialogerSetup }) => ({
    isOpen,
    dialogerSetup: newSetup ?? dialogerSetup,
  }));

/**
 * Returns an object containing actions related to the dialoger functionality.
 * @param set - The state setter function for the dialoger store state.
 * @returns An object with actions to perform dialoger operations.
 */
export const dialogerActions = (set: Set<DialogerStoreState>) => ({
  /**
   * Opens the dialoger and setup the settings.
   */
  onOpen: (newSetup?: DialogerSetup) => setDialogerSetup(set)(true, newSetup),

  /**
   * Closes the dialoger.
   */
  onClose: () => setDialogerSetup(set)(false),

  /**
   * Sets up the dialoger with the provided setup.
   * @param newSetup - The dialoger setup.
   */
  setSetup: (newSetup: DialogerSetup) => set({ dialogerSetup: newSetup }),
});
